import { ObjectId } from 'bson';
import { Identifier } from './Identifier';

export class UniqueEntityID extends Identifier {
  public IDENTIFIER_TYPE = 'UniqueEntityID';
  constructor(id?: string) {
    super(id ? id : new ObjectId().toString());
  }
}
